import type { ReactNode } from "react";

type Props = {
  itemKey: string;
  children: ReactNode;
  className?: string;
  variant?: "fade" | "slide-up" | "slide-left";
};

/** Blendet bei jedem Schlüsselwechsel sanft neuen Inhalt ein. */
export function InfoScreenCrossfade({
  itemKey,
  children,
  className = "",
  variant = "slide-left",
}: Props) {
  return (
    <div
      key={itemKey}
      className={`info-screen-crossfade info-screen-crossfade--${variant} ${className}`.trim()}
    >
      {children}
    </div>
  );
}
